import React from 'react';
import clsx from 'clsx';
import { MenuBar } from '@brighterion/br-ui';
import useBreadcrumbs from 'Hooks/useBreadcrumbs';
import ImportExportQueue from './ImportExportQueue';
import Breadcrumbs from './Breadcrumbs';
import LocaleInfo from '../LocaleInfo';
import styles from './SubNav.css';

const SubNav: React.FC = () => {
    const { breadcrumbs } = useBreadcrumbs() as BreadcrumbWrapper;

    if (breadcrumbs.length === 0) return null;

    return (
        <div className={clsx(styles.pageLocationBar)}>
            <MenuBar
                id='page-title-bar'
                leftAlignedMenuItems={[<Breadcrumbs key='breadcrumbs' />]}
                rightAlignedMenuItems={[<LocaleInfo key='localeInfo' />, <ImportExportQueue key='importExportQueue' />]}
            />
        </div>
    );
};

export default SubNav;
